module.exports = __webpack_public_path__ + "static/media/volontariato.1aacada9.png";